import { render, staticRenderFns } from "./ModalSidebarLink.vue?vue&type=template&id=1e252abc&"
import script from "./ModalSidebarLink.vue?vue&type=script&lang=js&"
export * from "./ModalSidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports